import { render, staticRenderFns } from "./ClientContraindications.vue?vue&type=template&id=440af6fc"
import script from "./ClientContraindications.vue?vue&type=script&lang=ts"
export * from "./ClientContraindications.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports